/**
 * Created by cedricgodefroy on 27/10/2017.
 */

// Require `PhoneNumberFormat`.
const phoneNumberFormat = require('google-libphonenumber').PhoneNumberFormat;
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
const phoneNumberType = require('google-libphonenumber').PhoneNumberType;

angular.module('FlexyBeautyApp.services')
    .factory('PhoneFormat', [function () {
        const phoneFormat = {
            defaultFormat: 'fr',
            unknowFormat: 'unknow',
            supportedCountries: ['fr', 'be', 'gb', 'ch', 'us'],
            companyCountry: 'fr',
            INTERNATIONAL_PREFIX: '+',
            EMPTY_NUMBER: ''
        };

        phoneFormat.setLocalCountry = function (companyCountry) {
            phoneFormat.companyCountry = companyCountry ? companyCountry.toLowerCase() : phoneFormat.defaultFormat;
        };

        phoneFormat.getLocalCountry = function(){
            return phoneFormat.companyCountry;
        };

        phoneFormat.isSupportedCountry = function(region) {
            return phoneFormat.supportedCountries.indexOf(region) !== -1;
        };

        phoneFormat.isValidDigitNumber = function(number){
            const regexp = new RegExp('^([0-9]|\\+)([0-9\\s])*$');
            return regexp.test(number);
        };

        phoneFormat.formatNumberWithoutCountry = function(number, isMobile) {
            let code = '';
            if (!number){
                return '';
            } else if (number && number.indexOf(phoneFormat.INTERNATIONAL_PREFIX) === -1) {
                if (isMobile && phoneFormat.isMobileNumber(number, phoneFormat.getLocalCountry())) {
                    code = phoneFormat.getLocalCountry();
                } else if (!isMobile && phoneFormat.isValidNumberForRegion(number, phoneFormat.getLocalCountry())) {
                    code = phoneFormat.getLocalCountry();
                } else {
                    code = phoneFormat.unknowFormat;
                }
            }

            try {
                if (code !== phoneFormat.unknowFormat){
                    const phoneNumber = phoneUtil.parse(number, code);
                    code = phoneUtil.getRegionCodeForNumber(phoneNumber);
                    if (phoneNumber != null && code != null && phoneFormat.isSupportedCountry(code.toLowerCase())) {
                        if (code === phoneFormat.getLocalCountry().toUpperCase()) {
                            number = phoneUtil.format(phoneNumber, phoneNumberFormat.NATIONAL);
                        }
                        else {
                            number = phoneUtil.format(phoneNumber, phoneNumberFormat.INTERNATIONAL);
                        }
                    }
                }
            } catch(error) {

            }

            return number;
        };

        phoneFormat.returnInternationalFormat = function(number) {
            if (!number) {
                return phoneFormat.EMPTY_NUMBER;
            }

            let code;
            if (number.indexOf(phoneFormat.INTERNATIONAL_PREFIX) === -1) {
                code = phoneFormat.getLocalCountry();
                if (code == null) {
                    code = phoneFormat.defaultFormat;
                }
            }

            if (phoneFormat.isValid(number, code)) {
                try {
                    const phoneNumber = phoneUtil.parse(number, code);
                    if (phoneNumber != null) {
                        number = phoneUtil.format(phoneNumber, phoneNumberFormat.INTERNATIONAL);
                    }
                } catch (error) {}
            }

            return number;
        };

        phoneFormat.isValid = function(phoneNumber, regionCode) {
            let isValid = false;

            try {
                const number = phoneUtil.parseAndKeepRawInput(phoneNumber, regionCode);
                isValid = phoneUtil.isValidNumber(number);
            } catch(e) {}

            return isValid;
        };


        phoneFormat.returnNationalFormat = function(number) {
            if (!number) {
                return phoneFormat.EMPTY_NUMBER;
            }

            if (number.indexOf(phoneFormat.INTERNATIONAL_PREFIX) === 0) {
                try {
                    const phoneNumber = phoneUtil.parse(number);
                    if (phoneNumber != null){
                        number = phoneUtil.format(phoneNumber, phoneNumberFormat.NATIONAL);
                    }
                } catch(error) {}
            }

            return number;
        };

        phoneFormat.isMobileNumber = function(number, region) {
            try {
                const phoneNumber = phoneUtil.parse(number, region);
                if (phoneNumber != null) {
                    if (phoneUtil.isValidNumberForRegion(phoneNumber, region) &&
                       (phoneUtil.getNumberType(phoneNumber) === phoneNumberType.MOBILE ||
                        phoneUtil.getNumberType(phoneNumber) === phoneNumberType.FIXED_LINE_OR_MOBILE)) {
                        return true;
                    }
                }
            } catch(error) {
            }
            return false

        };

        phoneFormat.formatNumberWithInternationalFormat = function(number, region) {
            try {
                if (region !== 'unknow') {
                    const phoneNumber = phoneUtil.parse(number, region);
                    if (phoneNumber != null) {
                        return phoneUtil.format(phoneNumber, phoneNumberFormat.INTERNATIONAL);
                    }
                }
            } catch(error) {
            }
            return number;
        };

        phoneFormat.formatNumber = function(number, region) {
            try {
                if (region !== 'unknow') {
                    const phoneNumber = phoneUtil.parse(number, region);
                    if (phoneNumber !== null){
                        if (region === phoneFormat.getLocalCountry()) {
                            const nationalPhone = phoneUtil.format(phoneNumber, phoneNumberFormat.NATIONAL);
                            if (nationalPhone && nationalPhone[0] !== "+" && nationalPhone[0] !== "0"){
                                return "0"+nationalPhone;
                            } else {
                                return nationalPhone;
                            }
                        }
                        return phoneUtil.format(phoneNumber, phoneNumberFormat.INTERNATIONAL);
                    }
                }
            } catch(error) {
            }
            return number;
        };

        phoneFormat.isValidNumberForRegion = function(number, region) {
            let isValideNumberForRegion = false;
            try {
                if (region === 'unknow') {
                    isValideNumberForRegion = true;
                } else{
                    const phoneNumber = phoneUtil.parse(number, region);
                    if (phoneNumber != null) {
                        if (phoneUtil.isValidNumberForRegion(phoneNumber, region)) {
                            isValideNumberForRegion = true;
                        }
                    }
                }
            } catch(error) {
            }
            return isValideNumberForRegion;
        };

        phoneFormat.getPrefixNumber = function(number, region) {
            let countryCode = '';
            if (region !== phoneFormat.unknowFormat) {
                try{
                    const phoneNumber = phoneUtil.parseAndKeepRawInput(number, region);
                    countryCode = phoneNumber.getCountryCode();
                } catch(e){

                }
            }
            return countryCode;
        };


        phoneFormat.getCountryFromNumber = function(number, isMobile) {
            let code = '';
            if (!number){
                code = (phoneFormat.isSupportedCountry(phoneFormat.getLocalCountry()) ? phoneFormat.getLocalCountry() : phoneFormat.unknowFormat);
                return code;
            }

            if (number && number.indexOf(phoneFormat.INTERNATIONAL_PREFIX) === -1) {
                if (isMobile && phoneFormat.isMobileNumber(number, phoneFormat.getLocalCountry())) {
                    code = phoneFormat.getLocalCountry();
                } else if (!isMobile && phoneFormat.isValidNumberForRegion(number, phoneFormat.getLocalCountry())) {
                    code = phoneFormat.getLocalCountry();
                } else{
                    code = phoneFormat.unknowFormat;
                }
            }

            try {
                if (code !== phoneFormat.unknowFormat) {
                    const phoneNumber = phoneUtil.parse(number, code);
                    if (phoneNumber !== null) {
                        const region = phoneUtil.getRegionCodeForNumber(phoneNumber);
                        if (region && phoneFormat.isSupportedCountry(region.toLowerCase()) && phoneUtil.isValidNumberForRegion(phoneNumber, region)) {
                            code = region;
                        } else {
                            code = phoneFormat.unknowFormat;
                        }
                    }
                }
            } catch(error) {
                code = phoneFormat.unknowFormat;
            }

            return code;
        };

        return phoneFormat;
    }]);


// WEBPACK FOOTER //
// ./js/services/tools/PhoneFormat.js